import { render, staticRenderFns } from "./ChangePosition.vue?vue&type=template&id=e12555a0&scoped=true"
import script from "./ChangePosition.vue?vue&type=script&lang=js"
export * from "./ChangePosition.vue?vue&type=script&lang=js"
import style0 from "./ChangePosition.vue?vue&type=style&index=0&id=e12555a0&prod&lang=scss&scoped=true"
import style1 from "./ChangePosition.vue?vue&type=style&index=1&id=e12555a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12555a0",
  null
  
)

export default component.exports